import { Box, Stack } from '@mui/material';
import { RefreshCw } from 'lucide-react';
import React from 'react';
import { ButtonPush } from '../ui/ButtonPush';
import SyncStatusBadge from './SyncStatusBadge';

/**
 * SyncControls — sync button + status badge for the project detail toolbar.
 * Hidden in standalone mode (where there's no remote to sync with).
 */
const SyncControls = ({ syncStatus, syncing, onSync }) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <SyncStatusBadge syncStatus={syncStatus} />
      <ButtonPush width="32px" height="32px" tooltipText="Sync" onClick={onSync} disabled={syncing}>
        <RefreshCw size={14} strokeWidth={2} className={syncing ? 'spin' : ''} />
      </ButtonPush>
    </Stack>
  );
};

export default SyncControls;
